import PublicPageView from "./PublicPageView";
import { useState } from "react";

export default function LivePreview({ business }) {
    const [lang, setLang] = useState(business?.default_lang || "en");
    return (
        <div className="flex flex-col items-center gap-4">
            <div className="flex items-center gap-2 text-xs text-zinc-400">
                <div className="text-[10px] font-bold uppercase tracking-[0.2em]">Live preview</div>
                <div className="inline-flex rounded-full border border-white/10 bg-zinc-900 p-0.5">
                    <button
                        type="button"
                        onClick={() => setLang("en")}
                        className={`px-2.5 py-1 text-[11px] font-medium rounded-full transition-colors ${
                            lang === "en" ? "bg-brand text-white" : "text-zinc-400"
                        }`}
                        data-testid="preview-lang-en"
                    >
                        EN
                    </button>
                    <button
                        type="button"
                        onClick={() => setLang("ar")}
                        className={`px-2.5 py-1 text-[11px] font-medium rounded-full transition-colors ${
                            lang === "ar" ? "bg-brand text-white" : "text-zinc-400"
                        }`}
                        data-testid="preview-lang-ar"
                    >
                        AR
                    </button>
                </div>
            </div>
            <div className="iphone-frame">
                <div className="iphone-inner no-scrollbar overflow-y-auto">
                    <PublicPageView business={business} forceLang={lang} insideFrame />
                </div>
            </div>
        </div>
    );
}
